import PadraoModel from 'src/core/model/PadraoModel.js'

export default class MidiaModel extends PadraoModel {
  recurso = 'midias';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Mídias';

  colunasGrid = [
    { name: 'acoes', label: 'Ações', field: 'acoes', sortable: false, style: 'width: 50px', align: 'left' },
    { name: 'id', label: 'Cód', field: 'id', sortable: true, align: 'left', buscaTipo: 'inteiro' },
    { name: 'nome', label: 'Nome', field: 'nome', descending: true, sortable: true, align: 'left', buscaTipo: 'texto' },
    { name: 'created_at', label: 'Criado em', field: 'created_at', sortable: true, align: 'left', buscaTipo: 'dataHoraMinuto' },
    { name: 'updated_at', label: 'Alterado em', field: 'updated_at', sortable: true, align: 'left', buscaTipo: 'dataHoraMinuto' }
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
